import RoleCard from "@/app/shared/roles-permissions/role-card";
import cn from "@/utils/class-names";
import { useEffect, useState } from "react";
import { fetchRoles } from "@/server/api-services";
import { Role, User } from "@/types";

interface RolesGridProps {
    roles: Role[];
    users: User[];
    refreshRoles: () => void;
    className?: string;
    gridClassName?: string;
}

export default function RolesGrid({
    roles,
    users,
    refreshRoles,
    className,
    gridClassName,
}: RolesGridProps) {
    return (
        <div className={cn("@container", className)}>
            {roles.length != 0 ? (
                <div
                    className={cn(
                        "grid grid-cols-1 gap-6 @[36.65rem]:grid-cols-2 @[56rem]:grid-cols-3 @[78.5rem]:grid-cols-4 @[100rem]:grid-cols-5",
                        gridClassName,
                    )}
                >
                    {roles.map((role) => (
                        <RoleCard
                            key={role.id}
                            id={role.id}
                            name={role.name}
                            permission={role?.permission}
                            className=""
                            color="#2465FF"
                            icon=""
                            users={users}
                            roles={roles}
                            refreshRoles={refreshRoles}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex items-center justify-center h-60 w-full border rounded border-muted">
                    <p>No roles found. Please create a role to get started.</p>
                </div>
            )}
        </div>
    );
}
